import { BaseMarket } from './baseMarket'
import { driftObj } from "@/aggregation/drift"
import { hyperliquidObj } from "@/aggregation/hyperliquid"

import { getBalances, getWallet } from "@/init";

import store from "@/store";
const { state } = store;

export const markets = [
  driftObj,
  hyperliquidObj
]

class Aggregation {
  platform
  activeMarket = null
  getFreeCollateralTime = 0
  refreshLogTime = 0
  perpListTime = 0
  refreshTokensBalancesTime = 0

  constructor() {

  }

  async init (platform) {
    console.log('-----init ' + platform.name)
    this.platform = platform
    this.activeMarket = markets.find(item => item.name == this.platform.name)
    this.chainCode = this.activeMarket.chainCode
    if (!this.activeMarket) return
    await this.activeMarket.init()
    await this.getPerpList()
    await this.getSpotList()
  }
  async initAccount (account) {
    if (!account) {
      state.userPositions = []
      state.userOrders = []
      state.userTrades = []

      state.pay = 0
      state.spotList = state.spotList.map(item => {
        return {
          ...item,
          balance1: null,
          balance: null,
        }
      })
      return
    }

    await this.activeMarket.initAccount(account)
    this.refreshLog(9)
    this.getFreeCollateral()
    this.subscribeUserTrades()
    await this.getSpotList()
  }

  async getPerpList () {
    if (this.perpListTime) clearTimeout(this.perpListTime)

    let list = await this.activeMarket.getPerpList()
    state.perpList = list.map(item => {
      let itemOld = state.perpList.find(o => o.symbol == item.symbol)
      return {
        price: 0,
        ...itemOld,
        ...item
      }
    })
    this.perpListTime = setTimeout(() => {
      this.getPerpList()
    }, 20 * 1000);
  }
  async getSpotList () {
    let data = await this.activeMarket.getSpotList()
    state.spotList = data
    if (state.account) this.refreshTokensBalances(100)
  }
  async getKLine (p) {
    let data = await this.activeMarket.getKLine(p)
    return data
  }

  async refreshTokensBalances (k) {
    let list = JSON.parse(JSON.stringify(state.spotList))
    let tokenAmounts = await this.activeMarket.getTokenAmounts(state.account)
    for (let i = 0; i < list.length; i++) {
      let item = list[i]
      let platform = state.platformList.find((obj) => obj.name == item.platform)
      if (platform) {
        item.platform = platform
      }
      item.balance1 = -999999999

      let fk = tokenAmounts.find(obj => ((item.marketIndex != undefined && item.marketIndex == obj.marketIndex) || item.symbol == obj.symbol))
      if (fk) {
        if (item.platform.name == "Hyperliquid") {
          item.balance1 = fk.balance
        } else {
          item.balance1 = Math.floor((fk.balance / (10 ** item.decimals)) * (10 ** item.scale)) / (10 ** item.scale)
        }
      }
    }
    if (state.account) {
      await getBalances(list, {
        chainCode: state.chainCode,
        account: state.account
      })

    }

    state.spotList = list
    if (!k) k = 0
    if (k < 6 * 4) {
      if (this.refreshTokensBalancesTime) {
        clearTimeout(this.refreshTokensBalancesTime)
      }
      this.refreshTokensBalancesTime = setTimeout(() => {
        this.refreshTokensBalances(k + 1)
      }, 1000 * (k + 5));
    }
    return list
  }

  async getFreeCollateral () {
    if (this.getFreeCollateralTime) clearTimeout(this.getFreeCollateralTime)
    this.getFreeCollateralTime = setTimeout(() => {
      this.getFreeCollateral()
    }, 1000 * 10);
    if (!state.account) return 0

    let pay = await this.activeMarket.getFreeCollateral(state.account)

    if (state.pay != pay) state.pay = pay
    return pay
  }
  async subscribePerpPrice () {
    await this.activeMarket.getPerpPrice(JSON.parse(JSON.stringify(state.perpList)), (data, msg) => {
      state.perpList = state.perpList.map(item => {
        let json = {
          ...item,
          ...data[item.symbol]
        }
        if (json.price) {
          json.h24Change = json.price - json.price24hAgo
          json.h24ChangePer = (json.h24Change / json.price24hAgo) * 100
        }
        return json
      })

      const pairObj = state.perpList.find(item => item.symbol == state.pairObj.symbol)
      if (pairObj) {
        state.pairObj = JSON.parse(JSON.stringify(pairObj))
      }
    })
  }
  async subscribeSpotPrice () {
    await this.activeMarket.getSpotPrice(JSON.parse(JSON.stringify(state.spotList)), (data, msg) => {
      state.spotList = state.spotList.map(item => {
        let json = {
          ...item,
          ...data[item.symbol]
        }
        return json
      })
    })
  }
  async subscribeUserTrades () {
    await this.activeMarket.subscribeUserTrades(state.account, (data) => {
      this.refreshLog(10, data)
    })
  }
  async subscribeOrderBook () {
    if (this.activeMarket.subscribeOrderBook) {
      await this.activeMarket.subscribeOrderBook(state.pairSymbol, (data, coin) => {
        this.getOrderBook(data)
      })
      await this.activeMarket.subscribeTrades(state.pairSymbol, (data, coin) => {
        this.getTrades(data)
      })

    }
  }
  async refreshLog (k, data) {
    if (this.refreshLogTime) clearTimeout(this.refreshLogTime)
    if (!k) k = 0
    if (k) {
      let isChange1 = await this.getOpenOrders(data ? data.orders : null)
      let isChange2 = await this.getPositions(data ? data.positions : null)
      if (isChange1 || isChange2 || k != 10) {
        this.getUserTrades()
        this.refreshTokensBalances(100)
      }
    }
    if (k > 3) return
    let time = 3000 + k * 1000
    this.refreshLogTime = setTimeout(() => {
      this.refreshLog(k + 1)
    }, time)
  }

  async deposit (params) {
    let wallet = getWallet()
    let data = await this.activeMarket.deposit(params, wallet)
    return data
  }
  async withdraw (params) {
    let wallet = getWallet()
    let data = await this.activeMarket.withdraw(params, wallet)
    return data
  }

  async createOrder (params) {
    let wallet = getWallet()
    let data = await this.activeMarket.createOrder(params, wallet)
    return data
  }

  async updateOrder (params) {
    let data = await this.activeMarket.updateOrder(params)
    return data
  }

  async cancelOrder (params) {
    let data = await this.activeMarket.cancelOrder(params)
    return data
  }


  async getPositions (list) {
    if (!state.account) {
      state.userPositions = []
      return
    }
    list = await this.activeMarket.getPositions(state.account, list)

    list.forEach(obj => {
      let stopList = []
      let takeList = []
      state.userOrders.forEach(item => {
        if (item.direction != obj.direction && ((item.marketIndex != undefined && item.marketIndex == obj.marketIndex) || item.symbol == obj.symbol)) {
          if (item.orderType) {
            if (item.orderType.indexOf('Stop') != -1) {
              stopList.push(item)
            }
            if (item.orderType.indexOf('Take') != -1) {
              takeList.push(item)
            }
            if (item.orderType == 'Limit' && item.platform.name != "Hyperliquid") {
              if ((obj.direction == 'Long' && obj.price < item.price) || (obj.direction == 'Short' && obj.price > item.price)) {
                takeList.push(item)
              } else {
                stopList.push(item)
              }
            }
          }
        }
      })
      obj.stopList = stopList.length ? stopList : null
      obj.takeList = takeList.length ? takeList : null

      let pairObj = state.perpList.find(o => (o.symbol == obj.symbol || o.marketIndex == obj.marketIndex))
      obj.pairObj = pairObj
      obj.leverage = pairObj.leverage
      obj.symbol = pairObj.symbol

      let platform = state.platformList.find(item => item.name == obj.pairObj.platform)
      if (platform) obj.platform = platform
    })

    let isChgane = false
    if (state.userPositions.length == list.length) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        let obj = state.userPositions.find(k => k.symbol == item.symbol)
        if (!obj || obj.size != item.size || obj.direction != item.direction) {
          isChgane = true
          break
        }
      }
    } else {
      isChgane = true
    }

    state.userPositions = list
    return isChgane
  }
  async getOpenOrders (list) {
    if (!state.account) {
      state.userOrders = []
      return
    }
    list = await this.activeMarket.getOpenOrders(state.account, list)
    list.forEach(obj => {
      let pairObj = state.perpList.find(o => (o.symbol == obj.symbol || o.marketIndex == obj.marketIndex))
      obj.pairObj = pairObj
      obj.leverage = pairObj.leverage
      obj.symbol = pairObj.symbol

      let platform = state.platformList.find(item => item.name == obj.pairObj.platform)
      if (platform) obj.platform = platform
    })

    let isChgane = false
    if (state.userOrders.length == list.length) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        let obj = state.userOrders.find(k => k.orderId == item.orderId)
        if (!obj || obj.size != item.size || obj.triggerPrice != item.triggerPrice || obj.price != item.price) {
          isChgane = true
          break
        }
      }
    } else {
      isChgane = true
    }

    state.userOrders = list.sort((a, b) => b.orderId - a.orderId)
    return isChgane
  }
  async getUserTrades () {
    if (!state.account) {
      state.userTrades = []
      return
    }
    let data = await this.activeMarket.getUserTrades(state.account)
    data.forEach(obj => {

      let pairObj = state.perpList.find(o => (o.symbol == obj.symbol || o.marketIndex == obj.marketIndex))
      if (pairObj) {
        obj.pairObj = pairObj
        obj.leverage = pairObj.leverage
        obj.symbol = pairObj.symbol
      }
      let platform = state.platformList.find(item => item.name == obj.pairObj.platform)
      if (platform) obj.platform = platform
    })
    state.userTrades = data

    return data
  }

  async getLiquidationPrice (params) {
    let data = await this.activeMarket.getLiquidationPrice(params)
    return data
  }
  async calculateFeeForQuoteAmount (params) {
    let data = await this.activeMarket.calculateFeeForQuoteAmount(params)
    return data
  }
  async getTokenAmount (params) {
    let data = await this.activeMarket.getTokenAmount(params)
    return data
  }
  async approveAgent () {
    let data = await this.activeMarket.approveAgent(state.account)
    return data
  }

  async getOrderBook (list) {
    let data = await this.activeMarket.getOrderBook(state.pairSymbol, list)
    state.orderbooks = data
  }

  async getTrades (list) {
    // let data = await this.activeMarket.getTrades(state.pairSymbol, obj)
    let newList = [...list, ...state.trades]
      .filter(item => item.symbol == state.pairSymbol)
      .sort((n, o) => o.time - n.time).slice(0, 30)
    state.trades = newList
  }
}

export const aggregationObj = new Aggregation()
